define(
    'checkPreInit/index',[
        'atn/atn', 'dataSource/oemMessages', './verifySession', './cacheBuster', './checkHttps',
        './checkReporting', './onInit', './rebrandingSteps'
    ],
    function(
        atn, oemMessages, verifySession, cacheBuster, checkHttps, checkReporting, onInit, rebrandingSteps
    ) {
        'use strict';
        var cacheStaircase = cacheBuster.cacheStaircase,
            retestAPI = cacheBuster.retestAPI,
            sessionStaircase = verifySession.sessionStaircase,
            fetchBrandingInfo = rebrandingSteps.fetchBrandingInfo,
            reloadFavicon = rebrandingSteps.reloadFavicon, 
            loginStaircase = atn.utils.createWaterfall([
                markNewReInit, cacheStaircase, fetchBrandingInfo, reloadFavicon, sessionStaircase, markLoggedIn
            ]),
            bootStaircase = atn.utils.createWaterfall([
                checkReporting.checkReporting,
                checkHttps.checkHttps,
                loginStaircase
            ]);

        return {
            loginStaircase: loginStaircase,
            bootStaircase: bootStaircase,
            cacheStaircase: cacheStaircase,
            retestAPI: retestAPI,
            sessionStaircase: sessionStaircase,
            onInit: onInit.onInit
        };

        function markLoggedIn(data, next) {
            atn.isLoggedOut(false);
            next();
        }

        function markNewReInit(data, next) {
            data.reInitAt = Date.now();
            atn.reInitAt(data.reInitAt);
            next();
        }

    });
